import * as Yup from 'yup';

import { TreatmentPlanResourceVersion } from '../constants/general';
import { EducationEvaluations, EducationSettings, ParentCaregiverRoles } from './constants';

export const EMAIL_TEST_REGEX = /^[\w-.+]+@([\w-]+\.)+[\w-]{2,4}$/g;

// TODO - Fields will be made required, as soon as bcbas are trained
export const getParentCaregiverSchema = (_isEmailRequired?: boolean) =>
  Yup.object().shape({
    id: Yup.number().optional(),
    role: Yup.string().trim().required(),
    name: Yup.string().trim().required().min(2),
    parent_marital_status: Yup.string().when('role', {
      is: ParentCaregiverRoles['Caregiver (not parent)'],
      then: () => Yup.string().nullable().notRequired(),
      otherwise: () => Yup.string().trim().required(),
    }),
    parent_mental_health_history: Yup.string().when('role', {
      is: ParentCaregiverRoles['Caregiver (not parent)'],
      then: () => Yup.string().nullable().notRequired(),
      otherwise: () => Yup.string().trim().required().min(2),
    }),
    email: Yup.string().when('role', {
      is: ParentCaregiverRoles['Caregiver (not parent)'],
      then: () => Yup.string().nullable().notRequired(),
      otherwise: () => Yup.string().nullable().notRequired(),
    }),
    phone: Yup.string().when('role', {
      is: ParentCaregiverRoles['Caregiver (not parent)'],
      then: () => Yup.string().nullable().notRequired(),
      otherwise: () => Yup.string().nullable().notRequired(),
    }),
    job: Yup.string().when('role', {
      is: ParentCaregiverRoles['Caregiver (not parent)'],
      then: () => Yup.string().nullable().notRequired(),
      otherwise: () => Yup.string().nullable().notRequired(),
    }),
    street_address_line_one: Yup.string().when('role', {
      is: ParentCaregiverRoles['Caregiver (not parent)'],
      then: () => Yup.string().nullable().notRequired(),
      otherwise: () => Yup.string().nullable().notRequired(),
    }),
    street_address_line_two: Yup.string().optional().nullable(),
    street_address_city: Yup.string().when('role', {
      is: ParentCaregiverRoles['Caregiver (not parent)'],
      then: () => Yup.string().nullable().notRequired(),
      otherwise: () => Yup.string().nullable().notRequired(),
    }),
    street_address_state: Yup.string().when('role', {
      is: ParentCaregiverRoles['Caregiver (not parent)'],
      then: () => Yup.string().nullable().notRequired(),
      otherwise: () => Yup.string().nullable().notRequired(),
    }),
    street_address_zip: Yup.string().when('role', {
      is: ParentCaregiverRoles['Caregiver (not parent)'],
      then: () => Yup.string().nullable().notRequired(),
      otherwise: () => Yup.string().nullable().notRequired(),
    }),
  });

// TODO - Reverting validation temporarily
// export const getParentCaregiverSchema = (_isEmailRequired?: boolean) =>
//   Yup.object().shape({
//     id: Yup.number().optional(),
//     role: Yup.string().trim().required(),
//     name: Yup.string().trim().required().min(2),
//     parent_marital_status: Yup.string().when('role', {
//       is: ParentCaregiverRoles['Caregiver (not parent)'],
//       then: () => Yup.string().nullable().notRequired(),
//       otherwise: () => Yup.string().trim().required(),
//     }),
//     parent_mental_health_history: Yup.string().when('role', {
//       is: ParentCaregiverRoles['Caregiver (not parent)'],
//       then: () => Yup.string().nullable().notRequired(),
//       otherwise: () => Yup.string().trim().required().min(2),
//     }),
//     email: Yup.string().when('role', {
//       is: ParentCaregiverRoles['Caregiver (not parent)'],
//       then: () => Yup.string().nullable().notRequired(),
//       otherwise: () =>
//         isEmailRequired
//           ? Yup.string().matches(EMAIL_TEST_REGEX).required()
//           : Yup.string().nullable().notRequired(),
//     }),
//     phone: Yup.string().when('role', {
//       is: ParentCaregiverRoles['Caregiver (not parent)'],
//       then: () => Yup.string().nullable().notRequired(),
//       otherwise: () => Yup.string().trim().required().min(10).max(10),
//     }),
//     job: Yup.string().when('role', {
//       is: ParentCaregiverRoles['Caregiver (not parent)'],
//       then: () => Yup.string().nullable().notRequired(),
//       otherwise: () => Yup.string().trim().required(),
//     }),
//     street_address_line_one: Yup.string().when('role', {
//       is: ParentCaregiverRoles['Caregiver (not parent)'],
//       then: () => Yup.string().nullable().notRequired(),
//       otherwise: () => Yup.string().trim().required(),
//     }),
//     street_address_line_two: Yup.string().optional().nullable(),
//     street_address_city: Yup.string().when('role', {
//       is: ParentCaregiverRoles['Caregiver (not parent)'],
//       then: () => Yup.string().nullable().notRequired(),
//       otherwise: () => Yup.string().trim().required(),
//     }),
//     street_address_state: Yup.string().when('role', {
//       is: ParentCaregiverRoles['Caregiver (not parent)'],
//       then: () => Yup.string().nullable().notRequired(),
//       otherwise: () => Yup.string().trim().required().min(2).max(2),
//     }),
//     street_address_zip: Yup.string().when('role', {
//       is: ParentCaregiverRoles['Caregiver (not parent)'],
//       then: () => Yup.string().nullable().notRequired(),
//       otherwise: () => Yup.string().trim().required().min(5),
//     }),
//   });

// Define schema for the parent/caregiver list
export const ParentCaregiverListSchema = Yup.array().test(
  'validateParentCaregiverList',
  'Invalid parent/caregiver list',
  function (value) {
    if (!value || value.length === 0) {
      return true;
    }
    const hasParentAndCaregiver = value?.some(
      (obj) => obj.role === ParentCaregiverRoles['Parent and caregiver'],
    );
    const hasParentNotCaregiver = value?.some(
      (obj) => obj.role === ParentCaregiverRoles['Parent (not a caregiver)'],
    );
    const hasCaregiverNotParent = value?.some(
      (obj) => obj.role === ParentCaregiverRoles['Caregiver (not parent)'],
    );

    if (hasParentAndCaregiver) {
      return true; // Validation passes if parent and caregiver are present
    }

    if (hasParentNotCaregiver && hasCaregiverNotParent) {
      return true; // Validation passes if both parent and caregiver exist without conflicting roles
    }

    if (hasParentNotCaregiver && !hasCaregiverNotParent) {
      return this.createError({
        message: '* At least one caregiver must be added',
        path: '[parentCaregivers]',
      });
    }

    if (hasCaregiverNotParent && !hasParentNotCaregiver && !hasParentAndCaregiver) {
      return this.createError({
        message: '* At least one parent must be added',
        path: '[parentCaregivers]',
      });
    }

    return this.createError({
      message: 'Invalid parent/caregiver list',
      path: '[parentCaregivers]',
    });
  },
);

export const siblingSchema = Yup.object().shape({
  id: Yup.number().optional(),
  name: Yup.string().trim().min(2).required(),
  age: Yup.number().integer().min(1).required(),
  diagnosis: Yup.string(),
});

export const EducationBackgroundSchema = Yup.object().shape({
  id: Yup.number().optional(),
  is_iep: Yup.boolean().required(),
  is_504: Yup.boolean().required(),
  education_setting: Yup.string().trim().required().oneOf(Object.values(EducationSettings)),
  education_description: Yup.string().required(),
  focus_area_description: Yup.string().required(),
  hours_per_week: Yup.string().required(),
  education_support: Yup.string().required(),
  education_evaluation: Yup.string().trim().required().oneOf(Object.values(EducationEvaluations)),
});

export const educationBackgroundInitialState = {
  is_iep: false,
  is_504: false,
  education_setting: '',
  education_evaluation: '',
};

export const FamilyBackgroundSchema = Yup.object().shape({
  client_family_background_version: Yup.string().trim().required(),
  family_medical_history_maternal: Yup.string().when('client_family_background_version', {
    is: (version: string) => version === TreatmentPlanResourceVersion.V2,
    then: () => Yup.string().trim().required().min(2),
    otherwise: () => Yup.string().nullable().notRequired(),
  }),
  family_medical_history_paternal: Yup.string().when('client_family_background_version', {
    is: (version: string) => version === TreatmentPlanResourceVersion.V2,
    then: () => Yup.string().trim().required().min(2),
    otherwise: () => Yup.string().nullable().notRequired(),
  }),
  community_involvement_religious_affiliations: Yup.string().when(
    'client_family_background_version',
    {
      is: (version: string) => version === TreatmentPlanResourceVersion.V2,
      then: () => Yup.string().trim().required().min(2),
      otherwise: () => Yup.string().nullable().notRequired(),
    },
  ),
});
